module.exports = __webpack_public_path__ + "static/media/jhipster.a071c439.png";